// Project Routes Registry
// Central registry for all project route configurations

import { getBASICRoutes } from './BASIC'
// Import other projects as needed
// import { getLTaxRoutes } from './projects/LTax'
// import { getLInvoiceRoutes } from './projects/LInvoice'
// import { getLEPRRoutes } from './projects/LEPR'
// import { getLAuthorizeRoutes } from './projects/LAuthorize'

/**
 * Project routes registry
 * Maps project names to their route configuration functions
 */
export const projectRoutesRegistry = {
	BASIC: {
		getProjectRoutes: getBASICRoutes,
		options: {
			useSignupToken: false
		}
	},
	// Add other projects here as they are migrated
	// LTax: {
	//   getProjectRoutes: getLTaxRoutes,
	//   options: {
	//     useSignupToken: true,
	//   },
	// },
	// LInvoice: {
	//   getProjectRoutes: getLInvoiceRoutes,
	//   options: {
	//     useSignupToken: false,
	//   },
	// },
	// LEPR: {
	//   getProjectRoutes: getLEPRRoutes,
	//   options: {
	//     useSignupToken: false,
	//   },
	// },
	// LAuthorize: {
	//   getProjectRoutes: getLAuthorizeRoutes,
	//   options: {
	//     useSignupToken: false,
	//   },
	// },
}

/**
 * Get route configuration for a project
 * @param {string} projectName - Project name
 * @returns {object|null} Route configuration or null if not found
 */
export const getProjectRouteConfig = (projectName) => {
	return projectRoutesRegistry[projectName] || null
}

/**
 * Check if project has route configuration
 * @param {string} projectName - Project name
 * @returns {boolean}
 */
export const hasProjectRouteConfig = (projectName) => {
	return projectName in projectRoutesRegistry
}
